import React from 'react';
import { Pricing } from '@/components/sections/Pricing/Pricing';
import { FAQ } from '@/components/sections/FAQ/FAQ';
import { CTA } from '@/components/sections/CTA/CTA';
import PageWrapper from '@/components/layout/PageWrapper';
import { META } from '@/config/constants';
import { pricingTiers, faqItems, pricingData } from '@/config/pricingData';

const PricingPage: React.FC = () => {
  return (
    <PageWrapper
      title={META.PRICING.TITLE}
      description={META.PRICING.DESCRIPTION}
      keywords={["pricing plans", "embedded iPaaS", "SaaS integration pricing", "flexible pricing"]}
    >
      <div>
        <Pricing tiers={pricingTiers} />
        <FAQ items={faqItems} />
        <CTA
          title={pricingData.cta.title}
          description={pricingData.cta.description}
          cta={pricingData.cta.cta}
        />
      </div>
    </PageWrapper>
  );
};

export default PricingPage;